import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Creatable } from 'react-select'

class InputSelectForm extends Component {
  constructor(props) {
    super(props)

    this.state = {
      itemSelectorValue: '',
      showInputSelectForm: false
    }

    this.selector = React.createRef()
  }

  render() {
    const { item } = this.props
    const { itemSelectorValue } = this.state

    return (
      <div className="select-form">
        <div className="select-form-escape" onClick={() => this.props.removeFocus()} />

        <div className="select-form-fields">
          <Creatable ref={this.selector}
            cache={false}
            autoFocus={true}
            openOnFocus={true}
            className="select-form-field"
            value={item}
            valueKey="id"
            labelKey="title"
            clearable={false}
            placeholder="Enter non-instrument"
            promptTextCreator={(label) => `Add "${label}"`}
            onOpen={() => {
              const { select } = this.selector.current
              if (select) this.selector.current.select.handleInputChange({target: {value: (item && item.title) || ''}})
            }}
            onInputKeyDown={(e) => {
              if (e.key === 'Backspace' && !itemSelectorValue) {
                this.props.deleteRiderItem(item.id)
                this.props.removeFocus()
              } else
              if (e.key === 'Escape') {
                this.props.removeFocus()
              } else {
                this.props.changeFocus(e)
              }
            }}
            onInputChange={(input) => {
              this.setState({itemSelectorValue: input})

              return input
            }}
            onChange={(item) => {
              this.props.itemIsSelected({...item, group: 'input'})
              this.props.removeFocus()
            }}
            onNewOptionClick={({title}) => {
              this.props.itemIsSelected({title, type: 'custom', class: 'non-instrument', group: 'input'})
              this.props.removeFocus()
            }}
            noResultsText={item.title ? 'Use backspace to remove' : 'No results'}
            options={[
              {
                id: 1,
                class: 'non-instrument',
                type: 'custom',
                title: 'echo'
              },
              {
                id: 2,
                class: 'non-instrument',
                type: 'custom',
                title: 'test'
              }
            ]}
            filterOptions={(options, filter) => {
              if (item.title && filter.length === 0) return null

              return options
            }} />
        </div>
      </div>
    )
  }
}

InputSelectForm.propTypes = {
  item: PropTypes.object,
  setFocus: PropTypes.bool,
  changeFocus: PropTypes.func,
  removeFocus: PropTypes.func,
  itemIsSelected: PropTypes.func,
  deleteRiderItem: PropTypes.func
}

InputSelectForm.defaultProps = {
  item: {},
  setFocus: false,
  changeFocus: function() {},
  removeFocus: function() {},
  itemIsSelected: function() {},
  deleteRiderItem: function() {}
}

export default InputSelectForm



// WEBPACK FOOTER //
// ./src/components/rider/rider-output/forms/input-select-form.js